import { useEffect } from 'react'
import { ChakraProvider } from '@chakra-ui/react'

import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { GlobalStyles } from '../GlobalStyles/GlobalStyles'
import { CHAKRA_LOCAL_STORAGE_KEY } from './constants'
import { AnalyticsProvider } from '../Analytics'
import { SwashbuckleTheme } from '../../types'

type SwashbuckleProviderProps = {
  theme: SwashbuckleTheme
  prepend?: boolean
  children: React.ReactElement
  analyticsClient?: any
}

export const SwashbuckleProvider = ({
  theme,
  prepend = false,
  children,
  analyticsClient,
}: SwashbuckleProviderProps) => {
  const swashbuckleCache = createCache({
    key: 'homebot',
    prepend,
  })

  useEffect(() => {
    if (theme) {
      const currentColorMode = localStorage.getItem(CHAKRA_LOCAL_STORAGE_KEY)

      if (
        theme.config.initialColorMode &&
        theme.config.initialColorMode !== currentColorMode
      ) {
        localStorage.setItem(
          CHAKRA_LOCAL_STORAGE_KEY,
          theme.config.initialColorMode
        )
      }
    }
  }, [theme])

  return (
    <CacheProvider value={swashbuckleCache}>
      <ChakraProvider theme={theme}>
        <GlobalStyles />
        <AnalyticsProvider client={analyticsClient}>
          {children}
        </AnalyticsProvider>
      </ChakraProvider>
    </CacheProvider>
  )
}
